<template>
  <v-dialog
    max-width="500px"
    class="contractSettings__dialog"
    background="white"
    :value="visible"
    @input="$emit('update:visible', $event)"
    persistent>
    <v-card dark v-if="visible" elevation="0" max-width="500px" class="mx-auto editor">
      <v-card-title class="font-weight-bold contractSettings__dialog-title justify-center mb-5">
        {{ dialogTitle }}
      </v-card-title>
      <v-card-text>
        <v-row no-gutters class="px-5">
          <v-col cols="12" v-for="field in formSchema" :key="field.model">
            <v-text-field v-if="field.type === 'text'" v-model="editableItem[field.model]" :label="field.label"></v-text-field>
            <v-textarea
              v-if="field.type === 'textarea'"
              v-model="editableItem[field.model]"
              :label="field.label"
              :counter="field.counter"></v-textarea>
            <v-switch v-if="field.type === 'switch'" v-model="editableItem[field.model]" :label="field.label"></v-switch>
            <v-checkbox v-if="field.type === 'checkbox'" v-model="editableItem[field.model]" :label="field.label"></v-checkbox>
            <v-select
              v-if="field.type === 'select'"
              v-model="editableItem[field.model]"
              :items="field.items"
              :label="field.label"
              :item-text="field.itemText"
              :item-value="field.itemValue"
              :multiple="field.multiple"></v-select>
            <v-combobox
              v-if="field.type === 'combobox'"
              v-model="editableItem[field.model]"
              :label="field.label"
              chips
              clearable
              multiple></v-combobox>

            <template v-if="type === 'category' && field.model === 'notes' && editableItem.notes">
              <div>
                <v-text-field v-model="editableItem.additionalInfo" label="Label für Notizfeld"></v-text-field>
                <v-textarea v-model="editableItem.notesDescription" label="Beschreibung für Auswahl" counter="150"></v-textarea>
                <v-switch v-model="editableItem.notesSelection" label="Vorgegebene Antwortmöglichkeiten"></v-switch>
                <v-combobox
                  v-if="editableItem.notesSelection"
                  v-model="editableItem.notesSelectionOptions"
                  label="Antwortoptionen"
                  chips
                  clearable
                  multiple></v-combobox>
              </div>
            </template>
          </v-col>

          <v-col cols="12" v-if="type === 'company' && editableItem.useMainCompany">
            <v-divider class="my-4"></v-divider>
            <p class="font-weight-bold">Stammcenter</p>
            <v-text-field v-model="editableItem.mainCompany.name" label="Firmenname (Stammcenter)"></v-text-field>
            <v-text-field v-model="editableItem.mainCompany.street" label="Strasse (Stammcenter)"></v-text-field>
            <v-text-field v-model="editableItem.mainCompany.city" label="PLZ / Ort (Stammcenter)"></v-text-field>
            <v-text-field v-model="editableItem.mainCompany.phone" label="Telefon (Stammcenter)"></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="contractSettings__dialog-actions">
        <v-btn class="white--text" text @click="$emit('update:visible', false)">Abbrechen</v-btn>
        <v-spacer></v-spacer>
        <v-btn class="white--text" text @click="$emit('save', { item: editableItem, type })">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "EditDialog",
  props: ["visible", "item", "type", "studios"],
  data() {
    return {
      editableItem: null,
    }
  },
  computed: {
    dialogTitle() {
      if (!this.type) return ""
      const titles = {
        company: "Vertragspartner",
        category: "Mitgliedschaftskategorie",
        paymentOption: "Zahlungsbedingung",
      }
      return `${titles[this.type] || "Eintrag"} bearbeiten`
    },
    formSchema() {
      if (!this.type) return []
      const schemas = {
        company: [
          { model: "name", label: "Firmenname", type: "text" },
          { model: "street", label: "Strasse", type: "text" },
          { model: "city", label: "PLZ / Ort", type: "text" },
          { model: "phone", label: "Telefon", type: "text" },
          { model: "studios", label: "Studios", type: "select", items: this.studios, itemText: "name", itemValue: "_id", multiple: true },
          { model: "useMainCompany", label: "Stammcenter verwenden", type: "switch" },
        ],
        category: [
          { model: "title", label: "Bezeichnung", type: "text" },
          { model: "description", label: "Beschreibung", type: "textarea", counter: 150 },
          { model: "notes", label: "Notizfeld anzeigen", type: "checkbox" },
          { model: "noSignUpFee", label: "Kein Aktivierungs-Tarif", type: "checkbox" },
          { model: "studios", label: "Studios", type: "select", items: this.studios, itemText: "name", itemValue: "_id", multiple: true },
        ],
        paymentOption: [
          { model: "title", label: "Bezeichnung", type: "text" },
          { model: "description", label: "Beschreibung", type: "textarea", counter: 150 },
          { model: "additionalInfo", label: "Weitere Informationen", type: "text" },
          { model: "selectDate", label: "Datum auswählbar?", type: "checkbox" },
          { model: "studios", label: "Studios", type: "select", items: this.studios, itemText: "name", itemValue: "_id", multiple: true },
        ],
      }
      return schemas[this.type] || []
    },
  },
  watch: {
    item: {
      handler(newItem) {
        this.editableItem = newItem ? JSON.parse(JSON.stringify(newItem)) : null

        // **NEU: Stellt sicher, dass das mainCompany-Objekt existiert, wenn der Schalter aktiv ist**
        if (this.type === "company" && this.editableItem) {
          if (this.editableItem.useMainCompany && !this.editableItem.mainCompany) {
            this.$set(this.editableItem, "mainCompany", { name: "", street: "", city: "", phone: "" })
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>
